import React, { useState } from 'react';
import PhotoAlbum from 'react-photo-album';
import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/styles.css';
import 'react-photo-album/rows.css';
import { useMediaQuery } from 'react-responsive';
import '@/components/ui/ImageGallery.scss';

type Image = {
  src: string;
  width: number;
  height: number;
  title?: string;
  link?: string;
  icon?: React.ElementType;
};

interface ImageGalleryProps {
  images: Image[];
  defaultIcon?: React.ElementType;
}

const ImageGallery: React.FC<ImageGalleryProps> = ({ images, defaultIcon }) => {
  const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
  const [index, setIndex] = useState(-1);

  const slides = images.map(img => ({
    src: img.src,
    width: img.width,
    height: img.height,
    title: img.title,
    link: img.link,
    icon: img.icon,
  }));

  const lightSlides = images.map(img => ({
    src: img.src,
    height: 800,
    title: img.title,
  }));

  return (
    <div>
      <section className="img-gallery">
        <PhotoAlbum
        rowConstraints={{ maxPhotos: isMobile ? 1 : 2 }}
          photos={slides}
          layout="rows"
          render={{
            photo: (props, { photo, width, height }) => {
              const Icon = photo.icon ?? defaultIcon;

              return (
                <div style={{ position: 'relative', width, height }} className="img-gallery__photo">
                  <img
                    src={photo.src}
                    style={{ width: '100%', height: '100%', display: 'block', cursor: 'pointer' }}
                    onClick={props.onClick}
                    alt={photo.title ?? ''}
                  />
                  {photo.title && (
                    <div className="img-gallery__caption">
                      {photo.link ? (
                        <a href={photo.link} target="_blank" rel="noreferrer">
                          {Icon && <Icon size={18} />}
                          <span>{photo.title}</span>
                        </a>
                      ) : (
                        <span className="img-gallery__caption-text">{photo.title}</span>
                      )}
                    </div>
                  )}
                </div>
              );
            },
          }}
          targetRowHeight={250}
          onClick={({ index }) => setIndex(index)}
          spacing={10}
        />
        <Lightbox
          open={index >= 0}
          index={index}
          close={() => setIndex(-1)}
          slides={lightSlides}
          plugins={[Captions]}
        />
      </section>
    </div>
  );
};

export default ImageGallery;
